module.exports = __webpack_public_path__ + "static/media/veterinaria.2843ee98.webp";